import memoized from '../memoized';

const NOT_DIGITS = /[^a-zA-Z ]/g;

export const onlyDigits = value => value.replace(NOT_DIGITS, '').trim();
export const hasNoDigit = memoized(message => value =>
  onlyDigits(value) === value.trim() ? undefined : message || true,
);
